export default __webpack_public_path__ + "static/media/dyeing1.71f8a85d.png";